var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerAudioMuted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.502,
    height: 33.973,
    viewBox: "0 0 32.502 33.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_254",
    "data-name": "Grupo 254",
    transform: "translate(-321.846 -1266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M321.846,1277.112v10.381h8.8l7.035,8.248v-25.82l-7.035,7.191Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    d: "M342.132,1290.691a1,1,0,0,1-.634-1.774,7.2,7.2,0,0,0,1.285-1.555,8.074,8.074,0,0,0,1.261-4.353,7.417,7.417,0,0,0-1.235-4.2,6.224,6.224,0,0,0-1.271-1.427l0,0,1.178-1.616a9.149,9.149,0,0,1,3.323,7.242,10.041,10.041,0,0,1-3.279,7.452A1,1,0,0,1,342.132,1290.691Z",
    transform: "translate(0 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    d: "M342.132,1293.848a1,1,0,0,1-.634-1.774,9.132,9.132,0,0,0,1.636-1.972,10.256,10.256,0,0,0,1.611-5.545,9.153,9.153,0,0,0-3.2-7.171,1,1,0,0,1,1.178-1.616,11.1,11.1,0,0,1,4.025,8.791,12.2,12.2,0,0,1-3.981,9.061A1,1,0,0,1,342.132,1293.848Z",
    transform: "translate(3.649 -2.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M342.132,1299.269a1,1,0,0,1-.634-1.774,12.443,12.443,0,0,0,2.237-2.686,14,14,0,0,0,2.214-7.592,12.56,12.56,0,0,0-4.407-9.83,1,1,0,0,1,1.178-1.616,12.519,12.519,0,0,1,2.651,2.9,15.036,15.036,0,0,1,2.578,8.554,16.2,16.2,0,0,1-2.572,8.733,14.09,14.09,0,0,1-2.612,3.089A1,1,0,0,1,342.132,1299.269Z",
    transform: "translate(6.398 -5.289)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_92",
    "data-name": "Trazado 92",
    d: "M23.839,30.473a1.5,1.5,0,0,1-1.159-.547L-1.158.953A1.5,1.5,0,0,1-.953-1.158a1.5,1.5,0,0,1,2.111.205L25,28.02a1.5,1.5,0,0,1-1.157,2.453Z",
    transform: "translate(3.002 3.5)",
    fill: "#000",
    opacity: 0.34
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_93",
    "data-name": "Trazado 93",
    d: "M23.839,30.473a1.5,1.5,0,0,1-1.159-.547L-1.158.953A1.5,1.5,0,0,1-.953-1.158a1.5,1.5,0,0,1,2.111.205L25,28.02a1.5,1.5,0,0,1-1.157,2.453Z",
    transform: "translate(4.002 1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerAudioMuted);
export default __webpack_public_path__ + "static/media/playerAudioMuted.1c0a362bd945d859c82096b250e2ff59.svg";
export { ForwardRef as ReactComponent };